export const LOAD_RESUMES_START = "LOAD_RESUMES_START";
export const LOAD_RESUMES_SUCCESS = "LOAD_RESUMES_SUCCESS";
export const GET_RESUME_START = "GET_RESUME_START";
export const GET_RESUME_SUCCESS = "GET_RESUME_SUCCESS";
export const GET_RESUME_FOR_EDIT_SUCCESS = "GET_RESUME_FOR_EDIT_SUCCESS";
export const UPDATE_RESUME_SUCCESS = "UPDATE_RESUME_SUCCESS";
